import { AsyncStoreItem } from '@lib/store';
import { JuniorPilotResponse } from 'src/sdk-servicing';

/**
 * JuniorPilot model
 */
export interface JuniorPilotModel {
  model: JuniorPilotResponse | null;
}

/**
 * JuniorPilotResponse model details
 */
export interface JuniorPilotStateDetails extends AsyncStoreItem {}

/**
 * JuniorPilot store state
 */
export interface JuniorPilotState extends JuniorPilotStateDetails, JuniorPilotModel {}

/**
 * Name of the JuniorPilot Store
 */
export const JUNIOR_PILOT_STORE_NAME = 'juniorPilot';

/**
 * JuniorPilot Store Interface
 */
export interface JuniorPilotStore {
  /** JuniorPilot state */
  [JUNIOR_PILOT_STORE_NAME]: JuniorPilotState;
}
